module.exports = __webpack_public_path__ + "static/media/saldo-icon.bb98e3ea.svg";